/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAccountBalanceResult } from '../../models/get-account-balance-result';

export interface GetAccountBalance$Params {
  SiteName?: string;
}

export function getAccountBalance(
  http: HttpClient,
  rootUrl: string,
  params?: GetAccountBalance$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetAccountBalanceResult>> {
  const rb = new RequestBuilder(rootUrl, getAccountBalance.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAccountBalanceResult>;
    }),
  );
}

getAccountBalance.PATH = '/Payments/account-balance';
